import { __decorate, __metadata, __param } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Component, EventEmitter, Inject, PLATFORM_ID, ɵɵinject, ElementRef, Renderer2, Output, HostListener, Directive, NgModule, InjectionToken, Optional, SkipSelf, Self } from '@angular/core';
import { NEVER, Observable, Subject, merge } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { is, Seq, List, Map, Record, fromJS } from 'immutable';
import { uniqueId, get, toPath, chain as chain$1, cloneDeepWith, isFunction, isObject, isNumber, isString, curry, bind, assign, defaults, defaultTo, capitalize, invoke } from 'lodash';
import { tap, map as map$1 } from 'rxjs/operators';
import { Category, LoggerType, CategoryLogFormat, CategoryConfiguration, LogLevel as LogLevel$1, CategoryServiceFactory } from 'typescript-logging';

import * as ɵngcc0 from '@angular/core';
let CoreService = class CoreService {
    constructor() { }
};
CoreService.ɵfac = function CoreService_Factory(t) { return new (t || CoreService)(); };
CoreService.ɵprov = ɵɵdefineInjectable({ factory: function CoreService_Factory() { return new CoreService(); }, token: CoreService, providedIn: "root" });
CoreService = __decorate([ __metadata("design:paramtypes", [])
], CoreService);

let CoreComponent = class CoreComponent {
    constructor() { }
    ngOnInit() {
    }
};
CoreComponent.ɵfac = function CoreComponent_Factory(t) { return new (t || CoreComponent)(); };
CoreComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CoreComponent, selectors: [["dino-core"]], decls: 2, vars: 0, template: function CoreComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " core works! ");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
CoreComponent = __decorate([ __metadata("design:paramtypes", [])
], CoreComponent);

class NullResizeSensor {
    constructor() {
        this.onResize = NEVER;
    }
    destroy() { }
}

// Do not use if ResizeObserver is undefined. This class does not check it.
class ObserverResizeSensor {
    constructor(element) {
        this.onResize = new EventEmitter();
        this.observer = new ResizeObserver(this.onResizeImpl.bind(this));
        this.observer.observe(element.nativeElement);
    }
    destroy() {
        this.observer.disconnect();
    }
    onResizeImpl(entries) {
        // There should only be a single entry
        const entry = entries[0];
        const { width, height } = entry.contentRect;
        this.onResize.emit({ width, height });
    }
}

const validPositions = ['absolute', 'relative', 'fixed'];
const style = `
  position: absolute;
  left: -10px;
  top: -10px;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: -1;
  visibility: hidden;
  max-width: 100%
`;
const subStyle = `
  position: absolute;
  left: 0;
  top: 0;
  transition: 0s;
`;
// Must be placed on elements that can have div children
// Based on https://github.com/marcj/css-element-queries
class GenericResizeSensor {
    constructor(element, renderer) {
        this.element = element;
        this.renderer = renderer;
        this.onResize = new EventEmitter();
        this.dirty = false;
        this.hiddenCheck = true;
        // Set element styles if necessary
        if (window) {
            const computedStyle = window.getComputedStyle(element.nativeElement);
            const position = computedStyle ? computedStyle.getPropertyValue('position') : undefined;
            if (validPositions.indexOf(position) < 0) {
                renderer.setStyle(element.nativeElement, 'position', 'relative');
            }
        }
        // Create top sensor element
        const sensorElement = this.sensorElement = renderer.createElement('div');
        renderer.setProperty(sensorElement, 'dir', 'ltr');
        renderer.addClass(sensorElement, 'dino-generic-resize-sensor');
        renderer.setAttribute(sensorElement, 'style', style);
        // Create sub sensor elements
        ([this.expandSensorElement, this.innerExpandSensorElement] = this.createSubSensor(renderer, sensorElement, 'expand'));
        ([this.shrinkSensorElement, this.innerShrinkSensorElement] = this.createSubSensor(renderer, sensorElement, 'shrink', 'width: 200%; height: 200%;'));
        // Append sensor
        renderer.appendChild(element.nativeElement, sensorElement);
        ({ width: this.lastWidth, height: this.lastHeight } = this.size = this.getSize());
        // Add events
        const { expandSensorElement, shrinkSensorElement } = this;
        const callback = this.onScrollImpl.bind(this);
        renderer.listen(expandSensorElement, 'scroll', callback);
        renderer.listen(shrinkSensorElement, 'scroll', callback);
        // Initial reset
        this.resetImpl();
    }
    destroy() {
        this.renderer.removeChild(this.element.nativeElement, this.sensorElement);
    }
    reset() {
        this.hiddenCheck = true;
        this.resetImpl();
    }
    getSize() {
        const native = this.element.nativeElement;
        if (native.getBoundingClientRect) {
            const { width, height } = native.getBoundingClientRect();
            return { width: Math.round(width), height: Math.round(height) };
        }
        else {
            return { width: native.offsetWidth, height: native.offsetHeight };
        }
    }
    createSubSensor(renderer, sensorElement, classSuffix, extraStyles = '') {
        const subSensor = renderer.createElement('div');
        const innerSubSensor = renderer.createElement('div');
        renderer.addClass(subSensor, 'dino-generic-resize-sensor-' + classSuffix);
        renderer.setAttribute(subSensor, 'style', style);
        renderer.setAttribute(innerSubSensor, 'style', subStyle + ' ' + extraStyles);
        renderer.appendChild(subSensor, innerSubSensor);
        renderer.appendChild(sensorElement, subSensor);
        return [subSensor, innerSubSensor];
    }
    resetSensors() {
        const { renderer, expandSensorElement, innerExpandSensorElement, shrinkSensorElement } = this;
        renderer.setStyle(innerExpandSensorElement, 'width', '100000px');
        renderer.setStyle(innerExpandSensorElement, 'height', '100000px');
        renderer.setProperty(expandSensorElement, 'scrollLeft', 100000);
        renderer.setProperty(expandSensorElement, 'scrollTop', 100000);
        renderer.setProperty(shrinkSensorElement, 'scrollLeft', 100000);
        renderer.setProperty(shrinkSensorElement, 'scrollTop', 100000);
    }
    resetImpl() {
        if (this.hiddenCheck) {
            const expandSensorElement = this.expandSensorElement;
            if (expandSensorElement.scrollLeft || expandSensorElement.scrollTop) {
                this.hiddenCheck = false;
            }
            else {
                this.resetSensors();
                if (!this.resetId) {
                    this.resetId = requestAnimationFrame(() => {
                        this.resetId = undefined;
                        this.resetImpl();
                    });
                }
            }
        }
        this.resetSensors();
    }
    onResizeImpl() {
        this.callbackId = undefined;
        if (!this.dirty) {
            return;
        }
        ({ width: this.lastWidth, height: this.lastHeight } = this.size);
        this.onResize.emit(this.size);
    }
    onScrollImpl() {
        const { width, height } = this.size = this.getSize();
        this.dirty = width !== this.lastWidth || height !== this.lastHeight;
        if (this.dirty && !this.callbackId) {
            this.callbackId = requestAnimationFrame(this.onResizeImpl.bind(this));
        }
        this.resetImpl();
    }
}

let ResizeSensorService = class ResizeSensorService {
    constructor(platformId) {
        const isBrowser = isPlatformBrowser(platformId);
        const hasResizeObserver = typeof ResizeObserver !== 'undefined';
        if (!isBrowser) {
            this.sensorType = NullResizeSensor;
        }
        else if (hasResizeObserver) {
            this.sensorType = ObserverResizeSensor;
        }
        else {
            this.sensorType = GenericResizeSensor;
        }
    }
    createSensor(element, renderer) {
        return new this.sensorType(element, renderer);
    }
};
ResizeSensorService.ɵfac = function ResizeSensorService_Factory(t) { return new (t || ResizeSensorService)(ɵngcc0.ɵɵinject(PLATFORM_ID)); };
ResizeSensorService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
ResizeSensorService.ɵprov = ɵɵdefineInjectable({ factory: function ResizeSensorService_Factory() { return new ResizeSensorService(ɵɵinject(PLATFORM_ID)); }, token: ResizeSensorService, providedIn: "root" });
ResizeSensorService = __decorate([ __param(0, Inject(PLATFORM_ID)),
    __metadata("design:paramtypes", [String])
], ResizeSensorService);

let AutoResizeDirective = class AutoResizeDirective {
    constructor(element, renderer, sensorService) {
        this.sensor = sensorService.createSensor(element, renderer);
        this.resize = this.sensor.onResize;
    }
    reset() {
        if (this.sensor.reset) {
            this.sensor.reset();
        }
    }
};
AutoResizeDirective.ɵfac = function AutoResizeDirective_Factory(t) { return new (t || AutoResizeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ResizeSensorService)); };
AutoResizeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: AutoResizeDirective, selectors: [["", "dinoAutoResize", ""]], hostBindings: function AutoResizeDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("auto-resize-reset", function AutoResizeDirective_auto_resize_reset_HostBindingHandler() { return ctx.reset(); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, outputs: { resize: "dinoAutoResize" } });
AutoResizeDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ResizeSensorService }
];
__decorate([
    Output('dinoAutoResize'),
    __metadata("design:type", Observable)
], AutoResizeDirective.prototype, "resize", void 0);
__decorate([
    HostListener('document:auto-resize-reset'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AutoResizeDirective.prototype, "reset", null);
AutoResizeDirective = __decorate([ __metadata("design:paramtypes", [ElementRef, Renderer2, ResizeSensorService])
], AutoResizeDirective);

let CoreModule = class CoreModule {
};
CoreModule.ɵfac = function CoreModule_Factory(t) { return new (t || CoreModule)(); };
CoreModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CoreModule });
CoreModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });

class NgxDinoEvent {
    constructor(type, data, processed, target, sourceEvent) {
        this.type = typeof type === 'string' ? type : type.type;
        this.data = data;
        this.processed = processed;
        this.target = target;
        this.sourceEvent = sourceEvent === undefined && typeof type !== 'string' ? type : sourceEvent;
    }
}

/**
 * Base class for immutable objects.
 *
 * Implements Immutable.js' `ValueObject` interface.
 */
class ImmutableValue {
    /**
     * Value equality test.
     *
     * @param other The value to compare for equality.
     * @returns Whether `this` is considered equal to `other`
     */
    equals(other) {
        if (this === other) {
            return true;
        }
        else if (other instanceof ImmutableValue) {
            return is(this.getCachedState(), other.getCachedState());
        }
        else {
            return false;
        }
    }
    /**
     * Calculates a hash code for this object.
     *
     * @returns The hash code for `this`
     */
    hashCode() {
        return this.getCachedState().hashCode();
    }
    /**
     * Fetches and caches the state on this object using `getState`.
     *
     * @returns The immutable value produced by `getState`
     */
    getCachedState() {
        return this.cachedState || (this.cachedState = this.getState());
    }
}

/**
 * Lexicographically compares two strings.
 *
 * @param s1 The first string.
 * @param s2 The second string.
 * @returns -1 if the first string is less than the second, 0 if they are equal, otherwise 1.
 */
function stringCompare(s1, s2) {
    if (s1 < s2) {
        return -1;
    }
    else if (s1 > s2) {
        return 1;
    }
    else {
        return 0;
    }
}
/**
 * Compares two numbers. -0 is ordered before +0 and NaNs are larger than any other value.
 *
 * @param n1 The first number.
 * @param n2 The second number.
 * @returns -1 if the first number is less than the second, 0 if they are equal, otherwise 1.
 */
function numberCompare(n1, n2) {
    const diff = n1 - n2;
    if (diff === 0) {
        // +0 and -0
        const n1pos = +((1 / n1) === Infinity);
        const n2pos = +((1 / n2) === Infinity);
        return n1pos - n2pos;
    }
    else if (diff !== diff) {
        // NaNs
        const n1Nan = n1 !== n1;
        const n2Nan = n2 !== n2;
        return n1Nan ? +(!n2Nan) : -1;
    }
    else {
        return diff;
    }
}
/**
 * Format values as `name<kw1: kv1, kw2: kv2,..., v1, v2,...>`.
 *
 * @param name The class/object name.
 * @param [keywords=[]] Keyword pairs.
 * @param [values=[]] Non-keyword values.
 * @returns The formatted string.
 */
function toStringHelper(name, keywords = [], values = []) {
    const kwString = Seq.Indexed(keywords).map(([key, data]) => {
        return `${key}: ${data}`;
    }).join('|');
    const valueString = Seq.Indexed(values).map((val) => {
        return '' + val;
    }).join('|');
    const contentString = [kwString, valueString].filter((s) => s).join('|');
    return `${name}<${contentString}>`;
}

// tslint:disable:no-bitwise
class Flags extends ImmutableValue {
    constructor(bits, _name) {
        super();
        this.bits = bits;
        this._name = _name;
    }
    get name() {
        if (this._name === undefined) {
            this._name = this.getNames().join('|');
        }
        return `Flags<${this._name}>`;
    }
    static combine(...flags) {
        return Flags.None.or(...flags);
    }
    has(...flags) {
        return this.all(...flags);
    }
    all(...flags) {
        return flags.every((f) => (f.bits & this.bits) === f.bits);
    }
    any(...flags) {
        return flags.some((f) => (f.bits & this.bits) === f.bits);
    }
    not() {
        return new Flags((~this.bits) & Flags.All.bits);
    }
    or(...flags) {
        return this.reduce((v1, v2) => v1 | v2, flags);
    }
    and(...flags) {
        return this.reduce((v1, v2) => v1 & v2, flags);
    }
    xor(...flags) {
        return this.reduce((v1, v2) => v1 ^ v2, flags);
    }
    // ImmutableValue implemenation
    getState() {
        return List.of(this.bits);
    }
    // toString
    toString() {
        return this.name;
    }
    // or/and/xor implemenation utility
    reduce(op, flags) {
        const result = flags.reduce((acc, f) => op(acc, f.bits), this.bits);
        return new Flags(result);
    }
    // Name utility
    withName(name) {
        return new Flags(this.bits, name);
    }
    getNames() {
        if (this.bits === Flags.None.bits) {
            return [Flags.None._name];
        }
        else if (this.bits === Flags.All.bits) {
            return [Flags.All._name];
        }
        else {
            return Flags.FlagList
                .filter((flag) => this.has(flag))
                .map((flag) => flag._name);
        }
    }
}
// Individual flags
// ----------------
// Operation always produces the same result for a given input.
Flags.Stateless = new Flags(1 << 0, 'Stateless');
// Operations output does not depend on the input.
Flags.InputIndependent = new Flags(1 << 1, 'InputIndependent');
// Operation has no side effects.
Flags.SideEffectFree = new Flags(1 << 2, 'SideEffectFree');
// List of individual flags
// ------------------------
Flags.FlagList = [
    Flags.Stateless,
    Flags.InputIndependent,
    Flags.SideEffectFree
];
// Special/Combination flags
// -------------------------
Flags.None = new Flags(0, 'None');
Flags.All = Flags.combine(...Flags.FlagList).withName('All');

class BaseOperator extends ImmutableValue {
    constructor(flags = Flags.None) {
        super();
        this.flags = flags;
        this.id = uniqueId('operator_');
    }
    // Helper method for setting the flags after the super constructor call
    // It is only allowed to be called in the derived constructor
    setFlags(flags) {
        this.flags = flags;
    }
    // Public interface
    get(data, cache) {
        try {
            cache.enter();
            return this.getImpl(data, cache);
        }
        finally {
            cache.exit();
        }
    }
    // ImmutableValue implementation
    getState() {
        return List.of(this.flags, this.getStateImpl());
    }
}
class BaseCache {
    // Methods to override in derived classes
    enter() { }
    exit() { }
    clear() { }
}

class NoopCache extends BaseCache {
    enter() { }
    exit() { }
    get(op, data) {
        return op.get(data, this);
    }
    clear() { }
}

class Operator extends BaseOperator {
    constructor(wrapped) {
        super(wrapped.flags);
        this.wrapped = wrapped;
        // No nesting wrapped operators
        if (wrapped instanceof Operator) {
            return wrapped;
        }
    }
    // Override base class methods
    getImpl(data, cache) {
        return this.wrapped.getImpl(data, cache);
    }
    getStateImpl() {
        return this.wrapped.getStateImpl();
    }
    get(data, cache = new NoopCache()) {
        return this.wrapped.get(data, cache);
    }
    // Binding for Operator#get. Makes it easier to use as a callback i.e.
    // [...].map(op.getter)
    get getter() {
        if (this.cachedGetter === undefined) {
            this.cachedGetter = (data) => this.get(data);
        }
        return this.cachedGetter;
    }
}

function Operand(operator, cached = true) {
    return function (target, key) {
        if (delete target[key]) {
            let getter = function () {
                const result = operator.get(this);
                return result;
            };
            if (cached) {
                const cacheKey = `__MEMOIZED_${key}__`;
                getter = function () {
                    if (this.hasOwnProperty(cacheKey)) {
                        return this[cacheKey];
                    }
                    else {
                        const result = operator.get(this);
                        Object.defineProperty(this, cacheKey, {
                            configurable: false,
                            enumerable: false,
                            writable: false,
                            value: result
                        });
                        return result;
                    }
                };
            }
            Object.defineProperty(target, key, {
                get: getter,
                enumerable: true,
                configurable: true
            });
        }
    };
}

// Constants
const flags = Flags.combine(Flags.Stateless, Flags.SideEffectFree);
class AccessorOperator extends BaseOperator {
    constructor(path, defaultValue) {
        super(flags);
        this.path = path;
        this.defaultValue = defaultValue;
    }
    getImpl(data, cache) {
        return get(data, this.path, this.defaultValue);
    }
    getStateImpl() {
        const pathList = List(toPath(this.path));
        return List.of(pathList, this.defaultValue);
    }
}

function createRaw(type, ...args) {
    return new type(...args);
}
function create(type, ...args) {
    return new Operator(createRaw(type, ...args));
}

function access(path, defaultValue) {
    return create(AccessorOperator, path, defaultValue);
}

// Constants
const flags$1 = Flags.combine(Flags.Stateless, Flags.SideEffectFree);
const state = List.of({});
class IdentityOperator extends BaseOperator {
    constructor() {
        super(flags$1);
    }
    getImpl(data, cache) {
        return data;
    }
    getStateImpl() {
        return state;
    }
}

function identity() {
    return create(IdentityOperator);
}

// Constants
const flags$2 = Flags.combine(Flags.Stateless, Flags.SideEffectFree);
class LookupOperator extends BaseOperator {
    // No good way to specialize the type of mapping to be fully compatible with
    // Immutable.Map's signature
    constructor(mapping, defaultValue) {
        super(flags$2);
        this.defaultValue = defaultValue;
        this.mapping = Map(mapping);
    }
    getImpl(data, cache) {
        return this.mapping.get(data, this.defaultValue);
    }
    getStateImpl() {
        return List.of(this.mapping, this.defaultValue);
    }
}

function lookup(mapping, defaultValue) {
    return create(LookupOperator, mapping, defaultValue);
}

// Constants
const flags$3 = Flags.combine(Flags.InputIndependent, Flags.SideEffectFree);
class AutoIdOperator extends BaseOperator {
    constructor(prefix = '', _counter = 0) {
        super(flags$3);
        this.prefix = prefix;
        this._counter = _counter;
    }
    get counter() {
        return this._counter;
    }
    getImpl(data, cache) {
        return `${this.prefix}${this._counter++}`;
    }
    getStateImpl() {
        return List.of(this.id);
    }
}

function autoId(prefix, start) {
    return create(AutoIdOperator, prefix, start);
}

// Constants
const flags$4 = Flags.combine(Flags.Stateless, Flags.SideEffectFree, Flags.InputIndependent);
class ConstantOperator extends BaseOperator {
    constructor(value) {
        super(flags$4);
        this.value = value;
    }
    getImpl(data, cache) {
        return this.value;
    }
    getStateImpl() {
        return List.of(this.value);
    }
}

function constant(value) {
    return create(ConstantOperator, value);
}

function unwrap(op) {
    return op.wrapped || op;
}

// Constants
const emptyState = List.of({});
function processOps(operators) {
    const normOps = chain$1(operators)
        .compact() // Remove falsy values
        .map(unwrap) // Unwrap Operators
        // Remove identity operators
        .reject((o) => o instanceof IdentityOperator)
        // Flatten nested chain operators
        .flatMap((o) => o instanceof ChainOperator ? o.operators.toArray() : o) // tslint:disable-line:no-use-before-declare
        .value();
    return reduceOps(normOps);
}
function reduceOps(operators) {
    let prevII = false; // Previous operator was input independent
    return operators.reduceRight((ops, op) => {
        if (!prevII || !op.flags.has(Flags.SideEffectFree)) {
            ops.push(op);
            prevII = op.flags.has(Flags.InputIndependent);
        }
        return ops;
    }, []).reverse();
}
function mergeFlags(operators) {
    const flags = operators.map((op) => op.flags);
    const firstOp = operators.first();
    const inputIndependent = firstOp && firstOp.flags.has(Flags.InputIndependent);
    return Flags.All
        .and(...flags.toArray())
        .or(inputIndependent ? Flags.InputIndependent : Flags.None);
}
class ChainOperator extends BaseOperator {
    constructor(...operators) {
        super();
        this.operators = List(processOps(operators));
        super.setFlags(mergeFlags(this.operators));
    }
    getImpl(data, cache) {
        return this.operators.reduce((result, op) => {
            return cache.get(op, result);
        }, data);
    }
    getStateImpl() {
        return this.operators.size !== 0 ? this.operators : emptyState;
    }
}

function chain(...ops) {
    return create(ChainOperator, ...ops);
}

function evaluate(obj, evaluator, state) {
    const removed = Map().asMutable();
    const newObj = cloneDeepWith(obj, (value, key, owner, stack) => {
        const args = { state, value, key, owner, stack };
        const { result, remove = false } = evaluator(args);
        if (remove && stack) {
            removed.update(stack.get(owner), (keys = List()) => keys.push(key));
            return value;
        }
        return result;
    });
    removed.forEach((keys, item) => deleteValues(item, keys));
    return newObj;
}
function deleteValues(item, keys) {
    if (isFunction(item.delete)) { // Javascript Map or Set
        keys.forEach(item.delete.bind(item));
    }
    else { // Object or Array
        keys.forEach((key) => (delete item[key]));
    }
}
// Cycle removal
class CycleRef extends Record({ path: List() }) {
    constructor(path) {
        super({ path });
    }
}
function cycleEvaluator({ state, value, key, owner }) {
    if (!isObject(value)) {
        return {};
    }
    else if (state.cycles.has(value)) {
        return { result: state.cycles.get(value) };
    }
    const parentPath = state.paths.get(owner);
    const path = key ? parentPath.push(key) : List();
    const ref = new CycleRef(path);
    state.paths.set(value, path);
    state.cycles.set(value, ref);
    return {};
}
function normalizeEvaluator({ state, value }) {
    if (value instanceof BaseOperator) {
        // Potential for eager evaluation here!
        state.flags = state.flags.and(value.flags);
        return { result: unwrap(value) };
    }
    return {};
}
function operatorEvaluator({ state, value }) {
    if (value instanceof BaseOperator) {
        const result = value.get(state.data, state.cache);
        return { result, remove: result === undefined };
    }
    return {};
}
class CombineOperator extends BaseOperator {
    constructor(schema) {
        super();
        const state = { flags: Flags.All };
        this.schema = evaluate(schema, normalizeEvaluator, state);
        super.setFlags(state.flags);
    }
    getImpl(data, cache) {
        const state = { data, cache };
        return evaluate(this.schema, operatorEvaluator, state);
    }
    getStateImpl() {
        const state = {
            paths: Map().asMutable(),
            cycles: Map().asMutable()
        };
        return fromJS(evaluate(this.schema, cycleEvaluator, state));
    }
}

function combine(schema) {
    return create(CombineOperator, schema);
}

class MapOperator extends BaseOperator {
    constructor(flags, mapper, ...args) {
        super(flags);
        this.mapper = mapper;
        this.args = args;
        this.callArgs = [undefined].concat(args);
    }
    getImpl(data, cache) {
        this.callArgs[0] = data;
        return this.mapper.apply(undefined, this.callArgs);
    }
    getStateImpl() {
        this.callArgs[0] = this.mapper;
        return List(this.callArgs);
    }
}

// Constants
const defaultFlags = Flags.combine(Flags.Stateless, Flags.SideEffectFree);
function map(...args) {
    if (isFunction(args[0])) {
        return create(MapOperator, defaultFlags, ...args);
    }
    else {
        return create(MapOperator, ...args);
    }
}

class BoundField extends ImmutableValue {
    constructor(id, field, operator) {
        super();
        this.id = id;
        this.field = field;
        this.operator = operator;
    }
    // Forward accesses/calls to field and operator
    get label() {
        return this.field.label;
    }
    get dataType() {
        return this.field.dataType;
    }
    get(data, cache) {
        return this.operator.get(data, cache);
    }
    get getter() {
        return this.operator.getter;
    }
    // toString
    toString() {
        const keywords = Seq.Keyed([
            ['id', this.id],
            ['field', this.field]
        ]);
        return toStringHelper('BoundField', keywords);
    }
    // ImmutableValue implementation
    getState() {
        return List.of(this.id, this.field);
    }
}

var DataType;
(function (DataType) {
    DataType["Boolean"] = "boolean";
    DataType["Number"] = "number";
    DataType["String"] = "string";
    DataType["Any"] = "any";
})(DataType || (DataType = {}));
class Field extends ImmutableValue {
    constructor(args) {
        super();
        let operatorMapping;
        ({
            id: this.id = uniqueId('field_'),
            label: this.label,
            dataType: this.dataType = DataType.Any,
            mapping: operatorMapping
        } = args);
        this.mapping = Seq.Keyed(operatorMapping)
            .map((op, id) => new BoundField(id, this, op)).toMap();
        // Bind the default to a BoundField with an equivalent Operator if possible
        if (this.mapping.has(Field.defaultSymbol)) {
            const op = this.mapping.get(Field.defaultSymbol).operator;
            const equiv = this.mapping.find((bf, key) => {
                return bf.operator.equals(op) && key !== Field.defaultSymbol;
            });
            if (equiv !== undefined) {
                this.mapping = this.mapping.set(Field.defaultSymbol, equiv);
            }
        }
    }
    // Public interface
    getBoundFieldIds() {
        return this.mapping
            .keySeq()
            .filter((id) => id !== Field.defaultSymbol)
            .valueSeq();
    }
    getBoundField(id = Field.defaultSymbol) {
        return this.mapping.get(id);
    }
    // toString
    toString() {
        const operators = Seq.Keyed(this.mapping
            .filter((_value, key) => key !== Field.defaultSymbol)
            .map((bf) => bf.operator)
            .entrySeq()
            .sort(([k1], [k2]) => stringCompare(k1, k2)));
        const keywords = Seq.Keyed([
            ['id', this.id],
            ['label', this.label],
            ['dataType', this.dataType],
            ['mapping', operators]
        ]);
        return toStringHelper('Field', keywords);
    }
    // ImmutableValue implementation
    getState() {
        const operatorMap = this.mapping.map((bf) => bf.operator);
        return List.of(this.dataType, operatorMap);
    }
}
Field.defaultSymbol = '__ngx-dino-field-default__';

function simpleField(args) {
    const { bfieldId, operator } = args;
    const bidSeq = bfieldId ? { [bfieldId]: operator } : {};
    const mapping = Seq.Keyed({
        [Field.defaultSymbol]: operator
    }).concat(bidSeq).toSeq();
    const newArgs = Object.assign(Object.assign({}, args), { mapping });
    return new Field(newArgs);
}

function multiField(args) {
    const mapping = Seq.Keyed(args.mapping);
    const defaultId = args.defaultId;
    const defaultOperator = defaultId && mapping.get(defaultId);
    const defaultSeq = defaultOperator ? {
        [Field.defaultSymbol]: defaultOperator
    } : {};
    const newMapping = mapping.concat(defaultSeq).toSeq();
    const newArgs = Object.assign(Object.assign({}, args), { mapping: newMapping });
    return new Field(newArgs);
}
function prePostMultiField(args) {
    const { pre, post, mapping } = args;
    const newMapping = Seq.Keyed(mapping)
        .map((op) => chain(pre, op, post)).toSeq();
    const newArgs = Object.assign(Object.assign({}, args), { mapping: newMapping });
    return multiField(newArgs);
}

function isDatumId(obj) {
    return isNumber(obj) || isString(obj);
}
function extractId(obj, bfield) {
    return isDatumId(obj) ? obj : bfield.get(obj);
}

const idSymbol = '__ngx-dino-datum-id__';
const rawDataSymbol = '__ngx-dino-datum-raw-data__';
function isDatum(obj) {
    return obj && isDatumId(obj[idSymbol]);
}
class Datum {
    constructor(id, rawData) {
        this[idSymbol] = id;
        this[rawDataSymbol] = rawData;
    }
}

class RawChangeSet {
    constructor(insert = [], remove = [], update = [], replace = []) {
        this.insert = insert;
        this.remove = remove;
        this.update = update;
        this.replace = replace;
    }
    static fromArray(insert) {
        return new RawChangeSet(insert);
    }
}

function datumFromRaw(bfield, rawData) {
    return new Datum(extractId(rawData, bfield), rawData);
}
function datumFromKVPair(bfield, [key, value]) {
    return new Datum(extractId(key, bfield), value);
}
// @dynamic
class ChangeSet {
    constructor(
    // Existing items are NOT replaced
    insert = Seq.Indexed(), 
    // Non-existing items are skipped
    remove = Seq.Indexed(), 
    // Non-existing items are skipped
    update = Seq.Indexed(), 
    // Non-existing items are inserted
    replace = Seq.Indexed()) {
        this.insert = insert;
        this.remove = remove;
        this.update = update;
        this.replace = replace;
    }
}
// tslint:disable-next-line:member-ordering
ChangeSet.fromRawChangeSet = curry((bfield, set) => {
    const boundDatumFromRaw = datumFromRaw.bind(undefined, bfield);
    const boundDatumFromKVPair = datumFromKVPair.bind(undefined, bfield);
    const insert = Seq.Indexed(set.insert)
        .map(boundDatumFromRaw).toIndexedSeq();
    const remove = Seq.Indexed(set.remove)
        .map(boundDatumFromRaw).toIndexedSeq();
    const update = Seq.Indexed(set.update)
        .map(boundDatumFromKVPair).toIndexedSeq();
    const replace = Seq.Indexed(set.replace)
        .map(boundDatumFromKVPair).toIndexedSeq();
    return new ChangeSet(insert, remove, update, replace);
});

function datumSeqToKeyed(datums) {
    const kvPairs = Seq.Indexed(datums).map((d) => [d[idSymbol], d]);
    return Seq.Keyed(kvPairs);
}
class ChangeCache extends ImmutableValue {
    constructor(strictMode = false, items = Map()) {
        super();
        this.strictMode = strictMode;
        this.items = items;
    }
    // Applies changes and returns a new cache
    update(changes) {
        const boundMergeInsert = bind(this.mergeInsert, this);
        const boundMergeReplace = bind(this.mergeReplace, this);
        const newItems = this.items
            .mergeWith(boundMergeInsert, datumSeqToKeyed(changes.insert))
            .mergeWith(boundMergeReplace, datumSeqToKeyed(changes.replace))
            .withMutations((map) => {
            const boundApplyUpdate = bind(this.applyUpdate, this, map);
            changes.update.forEach(boundApplyUpdate);
        }).withMutations((map) => {
            const boundRemoveItem = bind(this.removeItem, this, map);
            changes.remove.forEach(boundRemoveItem);
        });
        return new ChangeCache(this.strictMode, newItems);
    }
    clear() {
        return new ChangeCache(this.strictMode);
    }
    // Update utility
    mergeInsert(oldValue, newValue, key) {
        const message = `Item already inserted for key: ${key}`;
        return this.checkStrict(oldValue === undefined, newValue, message);
    }
    mergeReplace(_oldValue, newValue) {
        return newValue;
    }
    applyUpdate(map, item) {
        const key = item[idSymbol];
        const oldValue = map.get(key);
        if (oldValue === undefined) {
            const message = `Unable to update missing item for key: ${key}`;
            this.checkStrict(false, undefined, message);
            return;
        }
        const oldData = oldValue[rawDataSymbol];
        const dataUpdates = item[rawDataSymbol];
        const mergedData = assign({}, oldData, dataUpdates);
        map.set(key, mergedData);
    }
    removeItem(map, item) {
        const key = item[idSymbol];
        const message = `Unable to remove missing item for key: ${key}`;
        this.checkStrict(map.has(key), map.delete(key), message);
    }
    // strictMode utility
    checkStrict(condition, value, message) {
        if (this.strictMode && !condition) {
            throw new Error(message);
        }
        return value;
    }
    // ImmutableValue implementation
    getState() {
        return this.items;
    }
}

class CachedChangeStream {
    constructor(stream, strictMode) {
        this.stream = stream;
        this.emitStream = new Subject();
        this.cache = new ChangeCache(strictMode);
        this.cachedStream = merge(stream.pipe(tap({
            next: (changes) => (this.cache = this.cache.update(changes)),
            complete: () => this.emitStream.complete()
        })), this.emitStream);
    }
    reemit() {
        const replace = this.cache.items.valueSeq();
        const changes = new ChangeSet(undefined, undefined, undefined, replace);
        this.emitStream.next(changes);
    }
    clear() {
        const remove = this.cache.items.valueSeq();
        const changes = new ChangeSet(undefined, remove);
        this.cache = this.cache.clear();
        this.emitStream.next(changes);
    }
    asObservable() {
        return this.cachedStream;
    }
}

class DatumProcessor {
    constructor(extracted, computed) {
        this.extracted = extracted;
        this.computed = computed;
    }
    process(datum) {
        const rawData = datum[rawDataSymbol];
        this.extracted.forEach((bfield, prop) => {
            datum[prop] = bfield.get(rawData);
        });
        this.computed.forEach((bfield, prop) => {
            datum[prop] = bfield.get(datum);
        });
        return datum;
    }
}

function defaultCreate(id, rawData) {
    return new Datum(id, rawData);
}
class DataProcessor {
    constructor(rawCache, extracted = Seq.Keyed(), computed = Seq.Keyed(), config = {}) {
        this.rawCache = rawCache;
        this.emitStream = new Subject();
        this.datumProcessor = new DatumProcessor(extracted, computed);
        this.config = defaults({}, config, {
            strictMode: false,
            keepAlive: false,
            create: defaultCreate
        });
        const boundProcessChanges = bind(this.processChanges, this);
        const processedStream = rawCache.asObservable().pipe(map$1(boundProcessChanges), tap({ complete: () => !this.config.keepAlive && this.emitStream.complete() }));
        this.processedCache = new CachedChangeStream(merge(processedStream, this.emitStream), this.config.strictMode);
        const items = rawCache.cache.items.valueSeq();
        this.insertAll(items);
    }
    updateFields(extracted = Seq.Keyed(), computed = Seq.Keyed()) {
        const newExtracted = Map().merge(this.datumProcessor.extracted, extracted);
        const newComputed = Map().merge(this.datumProcessor.computed, computed);
        const items = this.rawCache.cache.items.valueSeq();
        this.datumProcessor = new DatumProcessor(newExtracted, newComputed);
        this.processedCache.clear();
        this.insertAll(items);
        return this;
    }
    asObservable() {
        return this.processedCache.asObservable();
    }
    // Processing utility
    processChanges(changes) {
        const insert = this.processInsert(changes.insert);
        const remove = this.processRemove(changes.remove);
        const update = this.processUpdate(changes.update);
        const replace = this.processReplace(changes.replace);
        return new ChangeSet(insert, remove, undefined, replace.concat(update).toIndexedSeq());
    }
    processInsert(insert) {
        const boundProcessDatum = bind(this.processDatum, this);
        return insert.map(boundProcessDatum).toIndexedSeq();
    }
    processRemove(remove) {
        return remove;
    }
    processUpdate(update) {
        const items = this.rawCache.cache.items;
        return update.map((datum) => {
            const id = datum[idSymbol];
            const rawDatum = items.get(id);
            return this.processDatum(rawDatum);
        }).toIndexedSeq();
    }
    processReplace(replace) {
        const boundProcessDatum = bind(this.processDatum, this);
        return replace.map(boundProcessDatum).toIndexedSeq();
    }
    processDatum(rawDatum) {
        const id = rawDatum[idSymbol];
        const rawData = rawDatum[rawDataSymbol];
        const datum = this.config.create(id, rawData);
        return this.datumProcessor.process(datum);
    }
    // Other utility
    insertAll(items) {
        const changes = this.processChanges(new ChangeSet(items));
        setTimeout(() => this.emitStream.next(changes), 0);
    }
}

// Stream to cache mapping
const cacheMap = Map().asMutable();
function getCache(stream, bfield) {
    let cache = cacheMap.get(stream);
    if (cache === undefined) {
        const newStream = stream.pipe(tap({ complete: () => cacheMap.delete(stream) }), map$1(ChangeSet.fromRawChangeSet(bfield)));
        cache = new CachedChangeStream(newStream);
        cacheMap.set(stream, cache);
    }
    return cache;
}
let DataProcessorService = class DataProcessorService {
    constructor() { }
    createProcessor(stream, bfield, extracted = {}, computed = {}, config = {}) {
        const rawCache = getCache(stream, bfield);
        const extractedSeq = Seq.Keyed(extracted);
        const computedSeq = Seq.Keyed(computed);
        return new DataProcessor(rawCache, extractedSeq, computedSeq, config);
    }
};
DataProcessorService.ɵfac = function DataProcessorService_Factory(t) { return new (t || DataProcessorService)(); };
DataProcessorService.ɵprov = ɵɵdefineInjectable({ factory: function DataProcessorService_Factory() { return new DataProcessorService(); }, token: DataProcessorService, providedIn: "root" });
DataProcessorService = __decorate([ __metadata("design:paramtypes", [])
], DataProcessorService);

var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Warn"] = 3] = "Warn";
    LogLevel[LogLevel["Error"] = 4] = "Error";
    LogLevel[LogLevel["Fatal"] = 5] = "Fatal";
    LogLevel[LogLevel["Off"] = 6] = "Off";
})(LogLevel || (LogLevel = {}));
// Should be `LogLevel`. Caused by https://github.com/ng-packagr/ng-packagr/issues/680
var LogLevel_Ext;
(function (LogLevel_Ext) {
    function fromString(name, defaultValue) {
        const level = defaultTo(LogLevel[capitalize(name)], defaultValue);
        if (level === undefined) {
            throw new Error(`Unknown log level name: ${name}`);
        }
        return level;
    }
    LogLevel_Ext.fromString = fromString;
    function toString(level, defaultValue) {
        const name = LogLevel[level] || defaultValue;
        if (name === undefined) {
            throw new Error(`Unknown log level: ${level}`);
        }
        return name;
    }
    LogLevel_Ext.toString = toString;
})(LogLevel_Ext || (LogLevel_Ext = {}));

var LoggerFactory_1, Logger_1;
var Utility;
(function (Utility) {
    function normalizeDataMessage(msg) {
        return isString(msg) ? { msg } : msg;
    }
    function normalizeMessage(msg) {
        if (isFunction(msg)) {
            return () => normalizeDataMessage(msg());
        }
        else {
            const normMsg = normalizeDataMessage(msg);
            return () => normMsg;
        }
    }
    Utility.normalizeMessage = normalizeMessage;
    function normalizeError(error) {
        return isFunction(error) ? error : () => error;
    }
    Utility.normalizeError = normalizeError;
})(Utility || (Utility = {}));
// Logger Configuration
const LoggerConfig = new InjectionToken('Logger Configuration');
// Logger Factory Base Class
let LoggerFactory = LoggerFactory_1 = class LoggerFactory {
    static use(factory) {
        return {
            provide: LoggerFactory_1,
            useExisting: factory
        };
    }
    createLogger(parent, config) {
        return new Logger(parent, config); // tslint:disable-line:no-use-before-declare
    }
};
LoggerFactory.ɵfac = function LoggerFactory_Factory(t) { return new (t || LoggerFactory)(); };
LoggerFactory.ɵprov = ɵɵdefineInjectable({ factory: function LoggerFactory_Factory() { return new LoggerFactory(); }, token: LoggerFactory, providedIn: "root" });
const ɵ0 = () => new Logger_1(undefined, { name: 'root' });
// Logger Base Class
// @dynamic
let Logger = Logger_1 = class Logger {
    constructor(parent, config) {
        this.children = [];
        this.name = config.name;
        this.parent = parent || undefined;
        this._level = defaultTo(config.level, LogLevel.Error);
        if (parent) {
            parent.children.push(this);
        }
    }
    get parents() { return this._parents || (this._parents = this.getAllParents()); }
    get level() { return this._level; }
    static withConfig(config) {
        return {
            provide: LoggerConfig,
            useValue: config
        };
    }
    static create() {
        return {
            provide: Logger_1,
            useFactory(factory, parent, config) {
                return factory.createLogger(parent, config);
            },
            deps: [LoggerFactory, [new Optional(), new SkipSelf(), Logger_1], [new Self(), LoggerConfig]]
        };
    }
    ngOnDestroy() {
        if (this.parent) {
            const index = this.parent.children.indexOf(this);
            if (index >= 0) { // Should always be true
                this.parent.children.splice(index, 1);
            }
        }
    }
    setLevel(level, propagate = true) {
        this._level = level;
        this.doSetLevel(level, propagate);
        if (propagate) {
            this.children.forEach((child) => child.setLevel(level, true));
        }
    }
    isLevelEnabled(level) { return level >= this.level && level !== LogLevel.Off; }
    isTraceEnabled() { return this.isLevelEnabled(LogLevel.Trace); }
    isDebugEnabled() { return this.isLevelEnabled(LogLevel.Debug); }
    isInfoEnabled() { return this.isLevelEnabled(LogLevel.Info); }
    isWarnEnabled() { return this.isLevelEnabled(LogLevel.Warn); }
    isErrorEnabled() { return this.isLevelEnabled(LogLevel.Error); }
    isFatalEnabled() { return this.isLevelEnabled(LogLevel.Fatal); }
    log(level, msg, error) {
        if (!this.isLevelEnabled(level) || level === LogLevel.Off) {
            return;
        }
        this.doLog(level, Utility.normalizeMessage(msg), error && Utility.normalizeError(error));
    }
    trace(msg) { this.log(LogLevel.Trace, msg); }
    debug(msg) { this.log(LogLevel.Debug, msg); }
    info(msg) { this.log(LogLevel.Info, msg); }
    warn(msg) { this.log(LogLevel.Warn, msg); }
    error(msg, error) { this.log(LogLevel.Error, msg, error); }
    fatal(msg, error) { this.log(LogLevel.Fatal, msg, error); }
    // Methods that can be overridden in derived loggers
    doLog(level, msg, error) {
        // Default does nothing
    }
    doSetLevel(level, propagate) {
        // Default does nothing
    }
    getAllParents() {
        const parents = [];
        let current = this.parent;
        while (current) {
            parents.push(current);
            current = current.parent;
        }
        return parents;
    }
};
Logger.ɵfac = function Logger_Factory(t) { return new (t || Logger)(ɵngcc0.ɵɵinject(Logger), ɵngcc0.ɵɵinject('this does not exist')); };
Logger.ctorParameters = () => [
    { type: Logger },
    { type: undefined, decorators: [{ type: Inject, args: ['this does not exist',] }] }
];
Logger.ɵprov = ɵɵdefineInjectable({ factory: ɵ0, token: Logger, providedIn: "root" });
Logger = Logger_1 = __decorate([ __param(1, Inject('this does not exist')),
    __metadata("design:paramtypes", [Logger, Object])
], Logger);

var Utility$1;
(function (Utility) {
    function createIntermediateCategories(logger) {
        const parents = logger.parents;
        const index = parents.findIndex((parent) => parent instanceof TypescriptLogger); // tslint:disable-line:no-use-before-declare
        const names = (index >= 0 ? parents.slice(0, index) : parents).map((parent) => parent.name);
        const firstCategory = index >= 0 ? parents[index].category : new Category('root');
        const parentCategory = names.reduceRight(((parent, name) => new Category(name, parent)), firstCategory);
        return parentCategory;
    }
    Utility.createIntermediateCategories = createIntermediateCategories;
})(Utility$1 || (Utility$1 = {}));
let TypescriptLoggerFactory = class TypescriptLoggerFactory extends LoggerFactory {
    createLogger(parent, config) {
        return new TypescriptLogger(parent, config); // tslint:disable-line:no-use-before-declare
    }
    configure(type = LoggerType.Console, format = new CategoryLogFormat(), createLogger) {
        const config = new CategoryConfiguration(LogLevel$1.Trace, type, format, createLogger || null);
        CategoryServiceFactory.setDefaultConfiguration(config, true);
    }
};
TypescriptLoggerFactory.ɵfac = /*@__PURE__*/ function () { let ɵTypescriptLoggerFactory_BaseFactory; return function TypescriptLoggerFactory_Factory(t) { return (ɵTypescriptLoggerFactory_BaseFactory || (ɵTypescriptLoggerFactory_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TypescriptLoggerFactory)))(t || TypescriptLoggerFactory); }; }();
// Workaround: Will be fixed by https://github.com/angular/angular/pull/25736
TypescriptLoggerFactory.ngInjectableDef = undefined;
TypescriptLoggerFactory.ɵprov = ɵɵdefineInjectable({ factory: function TypescriptLoggerFactory_Factory() { return new TypescriptLoggerFactory(); }, token: TypescriptLoggerFactory, providedIn: "root" });
let TypescriptLogger = class TypescriptLogger extends Logger {
    constructor(parent, config) {
        super(parent, config);
        this.category = new Category(config.name, Utility$1.createIntermediateCategories(this));
    }
    doLog(level, msg, error) {
        const methodName = LogLevel_Ext.toString(level).toLowerCase();
        const args = level < LogLevel.Error ? [msg] : [msg, error];
        invoke(this.category, methodName, ...args);
    }
};
TypescriptLogger.ɵprov = ɵɵdefineInjectable({ factory: ɵ0, token: TypescriptLogger, providedIn: "root" });
TypescriptLogger = __decorate([
    __param(1, Inject('this does not exist')),
    __metadata("design:paramtypes", [Logger, Object])
], TypescriptLogger);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CoreService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CoreComponent, [{
        type: Component,
        args: [{
                selector: 'dino-core',
                template: `
    <p>
      core works!
    </p>
  `
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResizeSensorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutoResizeDirective, [{
        type: Directive,
        args: [{
                selector: '[dinoAutoResize]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ResizeSensorService }]; }, { resize: [{
            type: Output,
            args: ['dinoAutoResize']
        }], reset: [{
            type: HostListener,
            args: ['document:auto-resize-reset']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CoreModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [CoreComponent, AutoResizeDirective],
                exports: [CoreComponent, AutoResizeDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CoreModule, { declarations: [CoreComponent, AutoResizeDirective], exports: [CoreComponent, AutoResizeDirective] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataProcessorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoggerFactory, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Logger, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
                useFactory: ɵ0
            }]
    }], function () { return [{ type: Logger }, { type: undefined, decorators: [{
                type: Inject,
                args: ['this does not exist']
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TypescriptLoggerFactory, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

const BaseEvent = typeof Event !== 'undefined' ? Event : class Event {
    constructor(name, options) {
        this.name = name;
        this.options = options;
    }
};
const eventName = 'auto-resize-reset';
let constructor;
let prototype;
// Old style class due to the way typescript inheritance is transpiled.
function AutoResizeResetEventConstructorFunction(options = {}) {
    const ev = new BaseEvent(eventName, Object.assign({ bubbles: true }, options));
    Object.setPrototypeOf(ev, prototype);
    return ev;
}
constructor = AutoResizeResetEventConstructorFunction;
constructor.eventName = eventName;
prototype = constructor.prototype = Object.create(BaseEvent.prototype);
prototype.constructor = constructor;
const AutoResizeResetEvent = constructor;

/*
 * Public API Surface of core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AutoResizeDirective, AutoResizeResetEvent, BaseCache, BaseOperator, BoundField, CachedChangeStream, ChangeCache, ChangeSet, CoreComponent, CoreModule, CoreService, DataProcessor, DataProcessorService, DataType, Datum, DatumProcessor, Field, Flags, LogLevel, LogLevel_Ext, Logger, LoggerConfig, LoggerFactory, NgxDinoEvent, Operand, Operator, RawChangeSet, TypescriptLogger, TypescriptLoggerFactory, access, autoId, chain, combine, constant, extractId, idSymbol, identity, isDatum, isDatumId, lookup, map, multiField, prePostMultiField, rawDataSymbol, simpleField, ɵ0, AutoResizeDirective as ɵa, ResizeSensorService as ɵb };

